import { reactive, toRefs } from '@vue/composition-api'
import qs from 'qs' //why qs? https://github.com/axios/axios#using-applicationx-www-form-urlencoded-format
import axios from "axios"
import useAlerts from '../../shared/composables/useAlerts'
import useCheckout from "../composables/useCheckout"
import useBilling from "../composables/useBilling"

//make this state variable global
let shipping;

export default function useShipping () {
    const { addAlert } = useAlerts();
    if (shipping == undefined) {
        shipping = reactive({
            shipMethod: window.checkout.shipping.method ? window.checkout.shipping.method : {},
            methods: window.checkout.shipping.methods ? window.checkout.shipping.methods : [],
            shippingSet: window.checkout.shipping.shippingSet ? window.checkout.shipping.shippingSet : false,
            shipNotes: window.checkout.shipping.shipNotes ? window.checkout.shipping.shipNotes : '',
            shipType: 'standardShipping'
        });
    }

    const { pricing, tax, addresses, calculateTax } = useCheckout();
    const { po, card, method } = useBilling();

    const getShipMethods = function(){
        const params = new URLSearchParams({
            addresses: JSON.stringify(addresses.value),
            pricing: JSON.stringify(pricing.value),
            paymentMethod: JSON.stringify(method.value),
            po: JSON.stringify(po.value),
            shipInfo: JSON.stringify(shipping),
            card: JSON.stringify(card.value),
            tax: JSON.stringify(tax.value)
        });

        axios.post('/actions/checkout.cfc?method=getShipMethods',params).then(function(response){
            if(response.status == 200){
                shipping.methods = response.data.methods;
                tax.value = response.data.tax;
                pricing.value.tax = Number(response.data.tax.taxAmt);
                shipping.shipType = response.data.shipType;
                if(shipping.shipType == 'noShip'){
                    shipping.shippingSet = true;
                    pricing.value.ship = 0;
                } else {
                    shipping.shipMethod = response.data.method;
                    pricing.value.ship = response.data.method.calcShipAmt;
                    shipping.shippingSet = true;
                }
                calculateTax();
            }
        }).catch((error) => {
            addAlert('An error occurred loading shipping methods.', 'alert-danger', 7000);
            console.log(error);
        });
    }

    const setShipMethod = function(method) {
        const params = qs.stringify(method);
        axios.post('/actions/checkout.cfc?method=setShipMethod', params).then(function(response){
            if(response.status == 200){
                shipping.shipMethod = method;
                pricing.value.ship = method.calcShipAmt;
                shipping.shippingSet = true;
            }
            calculateTax();
        }).catch((error) => {
            addAlert('An error occurred setting shipping method.', 'alert-danger', 7000);
            console.log(error);
        });
    }

    const clearShipping = function(){
        shipping.methods = [];
        shipping.shipMethod = {};
        shipping.shippingSet = false;
        shipping.shipType = 'standardShipping';
    }

    const setDefaultShippingOption = () => {
        return new Promise(function(resolve){
            if(shipping.methods.length > 0 && !shipping.shippingSet){
                resolve(false);
                //setShipMethod(shipping.methods[0].opts[0]);
            } else if (shipping.methods.length == 0 && shipping.shipType == 'standardShipping') {
                resolve(true);
                getShipMethods();
            } else if (shipping.shipType == 'noShip'){
                resolve(false);
            } else {
                resolve(false);
            }
        });
    }

    return {
        ...toRefs(shipping),
        getShipMethods,
        setShipMethod,
        clearShipping,
        setDefaultShippingOption
    }
}
